import { Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import StatusBlockDialog from "../../../components/Dialog/StatusBlockDialog";
import GlobalTable from "../../../components/Tables/GlobalTable";
import { setWorkerDetail } from "../../../lib/CompanySlice/WorkerDetailSlice";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { updateAllAcountStatus } from "../../../services/common/CommonApiFn";
import { getAllWorkersByCompanyId } from "../../../services/worker/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import useDebounce from "../../../components/hooks/useDebounce";
import { setSearchKeys } from "../../../lib/slices/search_key_slice";
import { t } from "i18next";

const headerData = [
  "joiningDateTime",
  "workerDetails",
  // "Services",
  "satisfactionRate",
  "status",
  "actions",
];

const tableRows = [
  "created_date",
  "worker_details",
  // "worker_services",
  "worker_reviews",
  "status",
  "actions",
];

const WorkerList = () => {
  const openBlockStatusDialog = useRef(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const [allWorkers, setAllWorkers] = useState();
  const userData = useSelector((state) => state.userData.user);
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const searchKey = useSelector((state) => state.SearchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(
    searchKey.companyWorkerUsername,
    1000
  );

  useEffect(() => {
    fetchAllWorkers(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const fetchAllWorkers = async (name) => {
    try {
      setIsLoading(true);
      const response = await getAllWorkersByCompanyId(userData?.adminId, name);
      if (response.data.status === "success") {
        const data = response.data.data.workers;
        setAllWorkers(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenConfirmDialog = (e, row) => {
    openBlockStatusDialog.current.openDialog({
      type: "Worker",
      status: e ? "Unblock" : "Block",
      data: row,
      event: e,
    });
  };

  const handleUpdateUserStatus = async (params) => {
    try {
      let payload = {
        status: params?.event,
        reason: params.reason,
      };
      setIsLoading(true);
      const response = await updateAllAcountStatus(
        params?.data?._id,
        payload,
        "Worker"
      );
      if (response.data.status === "success") {
        fetchAllWorkers("");
        handleOpenSnackBar("success", response.data.message);
        openBlockStatusDialog.current.closeDialog({});
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTab = (tab) => {
    dispatch(
      setActiveTab({ ...activeTab, company_worker_client: "add_edit_woker" })
    );
    dispatch(setWorkerDetail(null));
  };

  const handleNavigateToWorkersDetail = (params) => {
    dispatch(
      setActiveTab({ ...activeTab, company_worker_client: "add_edit_woker" })
    );
    dispatch(setWorkerDetail(params.row));
  };

  const handleSearchChange = (e) => {
    dispatch(
      setSearchKeys({
        ...searchKey,
        companyWorkerUsername: e.target.value,
      })
    );
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"custom_contained"}
          btnText={"createNew"}
          handleClickBtn={handleChangeTab}
        />
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("workersList")}
        secondaryHeading={t("workerDetailsDescription")}
        headProps={renderRightPart()}
        showSerach={true}
        searchValue={searchKey.companyWorkerUsername}
        onChange={handleSearchChange}
      >
        <GlobalTable
          minWidth={1200}
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allWorkers}
          showActions={true}
          showView={true}
          handleViewDetail={handleNavigateToWorkersDetail}
          handleChangeStatus={handleOpenConfirmDialog}
        />
        {/* <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={TableData}
          showActions={true}
          showDelete={true}
          showEdit={true}
          showCalender={true}
          showLogin={true}
        /> */}
        <StatusBlockDialog
          ref={openBlockStatusDialog}
          onConfirm={handleUpdateUserStatus}
        />
      </AppContainer>
    </>
  );
};

export default WorkerList;
